import {Nutriscore, Picto} from '../interfaces';
import {PRODUCT_TYPE} from './enums';

export const ALLERGENES: Picto[] = [
  {
    name: 'Arachides',
    id: 'ARA',
    fileName: 'arachides.svg',
  },
  {
    name: 'Celeri',
    id: 'CEL',
    fileName: 'celeri.svg',
  },
  {
    name: 'Crustacés',
    id: 'CRU',
    fileName: 'crustaces.svg',
  },
  {
    name: 'Fruits à coque',
    id: 'FCQ',
    fileName: 'fruits-a-coque.svg',
  },
  {
    name: 'Gluten',
    id: 'GLU',
    fileName: 'gluten.svg',
  },
  {
    name: 'Lait',
    id: 'LAI',
    fileName: 'lait.svg',
  },
  {
    name: 'Lupin',
    id: 'LUP',
    fileName: 'lupin.svg',
  },
  {
    name: 'Mollusques',
    id: 'MOL',
    fileName: 'mollusques.svg',
  },
  {
    name: 'Moutarde',
    id: 'MOU',
    fileName: 'moutarde.svg',
  },
  {
    name: 'Oeuf',
    id: 'OEU',
    fileName: 'oeuf.svg',
  },
  {
    name: 'Poisson',
    id: 'POI',
    fileName: 'poisson.svg',
  },
  {
    name: 'Sésame',
    id: 'SES',
    fileName: 'sesame.svg',
  },
  {
    name: 'Soja',
    id: 'SOJ',
    fileName: 'soja.svg',
  },
  {
    name: 'Sulfite',
    id: 'SUL',
    fileName: 'sulfite.svg',
  },
];

export const ORIGINES: Picto[] = [
  {
    name: 'Bio',
    id: 'BIC',
    fileName: 'bio.png',
  },
  {
    name: 'Label Rouge',
    id: 'LAB',
    fileName: 'lr.svg',
  },
  {
    name: 'La région du goût',
    id: 'REG',
    fileName: 'lrg.png',
  },
  {
    name: 'Nouvelle recette du chef',
    id: 'NEW',
    fileName: 'nrc.png',
  },
  {
    name: 'Cuisiné par nos soins',
    id: 'SOI',
    fileName: 'cns.png',
  },
  {
    name: 'Poisson frais',
    id: 'POF',
    fileName: 'pf.png',
  },
  {
    name: 'Produit bio',
    id: 'BIO',
    fileName: 'prb.png',
  },
  {
    name: 'Produit eco',
    id: 'ECP',
    fileName: 'pre.png',
  },
  {
    name: 'Produit frais',
    id: 'PRF',
    fileName: 'prf.png',
  },
  {
    name: 'Produit local',
    id: 'LOC',
    fileName: 'prl.png',
  },
  {
    name: 'Produit vege',
    id: 'VEG',
    fileName: 'prv.png',
  },
  {
    name: 'Porc français',
    id: 'POC',
    fileName: 'pof.svg',
  },
  {
    name: 'Viande bovine française',
    id: 'VBF',
    fileName: 'vbf.svg',
  },
  {
    name: 'Volaille française',
    id: 'VOF',
    fileName: 'vlf.svg',
  },
];

export const PRODUCT_TYPES: Picto[] = [
  {
    name: 'Entrée',
    id: PRODUCT_TYPE.ENT,
    fileName: 'entrees.svg',
  },
  {
    name: 'Plat',
    id: PRODUCT_TYPE.PLA,
    fileName: 'plats.svg',
  },
  {
    name: 'Accompagnement',
    id: PRODUCT_TYPE.ACC,
    fileName: 'accompagnements.svg',
  },
  {
    name: 'Dessert',
    id: PRODUCT_TYPE.DES,
    fileName: 'desserts.svg',
  },
  {
    name: 'Fromage',
    id: PRODUCT_TYPE.FRO,
    fileName: 'fromages.svg',
  },
  // {
  //   name: 'Laitage',
  //   id: PRODUCT_TYPE.LAI,
  //   fileName: 'laitages.svg',
  // },
  {
    name: 'Boisson',
    id: PRODUCT_TYPE.BOI,
    fileName: 'boissons.svg',
  },
  // {
  //   name: 'Autre',
  //   id: PRODUCT_TYPE.AUT,
  //   fileName: 'formules.svg',
  // },
  // {
  //   name: 'Formule',
  //   id: PRODUCT_TYPE.FOR,
  //   fileName: 'formules.svg',
  // },
];

export const NUTRISCORE: Nutriscore[] = [
  {
    id: 1,
    fileName: '1.svg',
    fileNameVertical: 'v_1.svg',
  },
  {
    id: 2,
    fileName: '2.svg',
    fileNameVertical: 'v_2.svg',
  },
  {
    id: 3,
    fileName: '3.svg',
    fileNameVertical: 'v_3.svg',
  },
  {
    id: 4,
    fileName: '4.svg',
    fileNameVertical: 'v_4.svg',
  },
  {
    id: 5,
    fileName: '5.svg',
    fileNameVertical: 'v_5.svg',
  },
];
